const CorrectiveActionsReducer = (state = {}, action) => {
    switch (action.type) {
      case "CORRECTIVE_DOCS":
        return Object.assign({}, state, {
          correctdocnames: action.data,
        });
      case "CORRECTIVE_UPLOAD":
        return Object.assign({}, state, {
          correctdocs: action.data,
        });
        case "HIDE_CORRECTDEL":
          return Object.assign({}, state, {
            hidecorrect: action.data,
          });
          case "SAVE_CORRECTDOC":
          return Object.assign({}, state, {
            savecorrect: action.data,
          });
        default:
      return state;
  }
};

export default CorrectiveActionsReducer;